__turbopack_context__.v({
  "banner-wrapper": "settings-module-scss-module__wnnPCq__banner-wrapper",
  "controls": "settings-module-scss-module__wnnPCq__controls",
  "copied-confirmation": "settings-module-scss-module__wnnPCq__copied-confirmation",
  "copy-api-key-content": "settings-module-scss-module__wnnPCq__copy-api-key-content",
  "copy-api-key-display": "settings-module-scss-module__wnnPCq__copy-api-key-display",
  "copy-button": "settings-module-scss-module__wnnPCq__copy-button",
  "copy-button-wrapper": "settings-module-scss-module__wnnPCq__copy-button-wrapper",
  "field": "settings-module-scss-module__wnnPCq__field",
  "field-content": "settings-module-scss-module__wnnPCq__field-content",
  "field-control": "settings-module-scss-module__wnnPCq__field-control",
  "field-heading": "settings-module-scss-module__wnnPCq__field-heading",
  "field-heading-icon-wrapper": "settings-module-scss-module__wnnPCq__field-heading-icon-wrapper",
  "field-warning": "settings-module-scss-module__wnnPCq__field-warning",
  "is-shown": "settings-module-scss-module__wnnPCq__is-shown",
  "main": "settings-module-scss-module__wnnPCq__main",
  "menu": "settings-module-scss-module__wnnPCq__menu",
  "menu-icon": "settings-module-scss-module__wnnPCq__menu-icon",
  "settings-api-key-copy": "settings-module-scss-module__wnnPCq__settings-api-key-copy",
  "settings-api-key-wrapper": "settings-module-scss-module__wnnPCq__settings-api-key-wrapper",
  "settings-api-qr-code": "settings-module-scss-module__wnnPCq__settings-api-qr-code",
  "settings-form": "settings-module-scss-module__wnnPCq__settings-form",
  "settings-page": "settings-module-scss-module__wnnPCq__settings-page",
});
